export default "/images/vendor/flag-icon-css/flags/4x3/pn.svg?0911eddaa4bb5cbf54b8d318c454fe35";